import { makeRoute } from '~/utils/route';
import DashboardController from './dashboard.controller';
import template from './dashboard.html';
import './dashboard.scss';

export default makeRoute({
	path: '/dashboard/:kid',
	template,
	controller: DashboardController,
	title: 'TDB',
});
